export default __webpack_public_path__ + "static/media/close.bd336cc3.svg";